import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdClose } from "react-icons/md";
import { useState } from "react";
import Loader from "react-loader-spinner";
import "react-phone-input-2/lib/style.css";

import { toastMessage } from "../../../utils/toast";
import * as userActions from "../../../Redux/Actions/user";
import { useTranslation } from "react-i18next";
import OTPVerifyModal from "../OTPVerityModal/OTPVerifyModal";
import * as userAuthActions from "../../../Redux/Actions/user";
import { getLocaleValue } from "../../../utils";

export default function UserAccountDeleteModal({
  showModal,
  loading,
  handleCancel,
  history,
  footerOption1,
  footerOption2,
  t,
}) {
  const dispatch = useDispatch();
  const [errMsg, setErrMsg] = useState("");
  const [email, setEmail] = useState("");
  const [buttonLoading, setButtonLoading] = useState("");
  const [condition, setCondition] = useState("");
  const [showVerificationModal, setShowVerificationModal] = useState(false);

  const userData = useSelector(({ User }) => User.data);

  const handleOk = () => {
    if (condition) {
      setButtonLoading(true);
      userActions
        .deleteAccount(userData.UserId)
        .then((res) => {
          if (res && res.status === 200) {
            toastMessage("success", "Account Deleted Successfully");
            dispatch(userAuthActions.userAuthLogout());
            setButtonLoading(false);
            localStorage.removeItem("jwt");
            history.push("/");
          } else {
            toastMessage("error", "Erro Occured");
            setButtonLoading(false);
          }
        })
        .catch((err) => {
          toastMessage("error", "Error Occured");
          setButtonLoading(false);
        });
    } else {
      setErrMsg("Please Check the Terms And Conditions");
    }
  };

  return (
    <div>
      <div
        className="modal"
        style={{ display: showModal ? "block" : "", top: "50%" }}
      >
        <div className="modal-dialog" style={{ maxWidth: "600px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 style={{ color: "white" }}></h5>
              <button
                type="button"
                className="close p-1 rounded"
                aria-label="Close"
                onClick={handleCancel}
                style={{ border: "none" }}
              >
                <MdClose />
              </button>
            </div>
            <div className="modal-body">
              <label className="p-3 form-label">
                {getLocaleValue("delete_account_header")}
              </label>
              <div
                className="form-check"
                style={{ marginLeft: "15px", mariginTop: "20px" }}
              >
                <input
                  className="form-check-input"
                  type="checkbox"
                  required={true}
                  checked={condition}
                  value=""
                  id="defaultCheck1"
                  onClick={(e) => {
                    setCondition(e.target.checked);
                    setErrMsg("");
                  }}
                />
                <label className="form-check-label">
                  <a
                    href="https://aamergroup.ae/home/privacy_policy#:~:text=Aamer%20App%20Account,which%20we%20operate"
                    target={"_blank"}
                  >
                    {" "}
                    I have read & accepted terms & conditions{" "}
                  </a>
                </label>
              </div>
            </div>

            {errMsg && <p className="text-danger text-center">{errMsg}</p>}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light-danger font-weight-bold"
                onClick={handleCancel}
              >
                {footerOption2 ? footerOption2 : "Cancel"}
              </button>
              <button
                type="button"
                className="btn btn-primary font-weight-bold d-flex align-items-center"
                onClick={handleOk}
                disabled={buttonLoading}
              >
                {footerOption1 ? footerOption1 : "Submit"}
                {buttonLoading && (
                  <Loader
                    type="Oval"
                    color="#fff"
                    height={20}
                    width={20}
                    style={{ marginLeft: "10px" }}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop show"></div>
      {showVerificationModal && (
        <OTPVerifyModal
          t={t}
          showModal={showVerificationModal}
          history={history}
          email={email}
          handleCancel={handleCancel}
          footerOption1={"Submit"}
          footerOption2={"Cancel"}
        >
          {" "}
        </OTPVerifyModal>
      )}
    </div>
  );
}
